<template lang="pug">
v-main
  v-container(fluid)
    v-card
        v-toolbar.elevation-0
            v-toolbar-title Setting
        v-divider
        v-card-text
            v-form(class="my-2" ref="form")
                v-row(no-gutters)
                    v-col(cols="3") 
                        v-subheader(color="black") Choose Business Unit
                    v-col(cols="6")
                        v-autocomplete(
                            ref="business_units"
                            :items="business_units"
                            v-model="setting.bu"
                            label="Business Unit"
                            item-text="name"
                            item-value="id"
                            @change="getData(setting.bu.id)"
                            return-object
                        )

                v-row(no-gutters)
                    v-col(cols="3") 
                        v-subheader Theme Colors
                    v-col(cols="6")
                        v-radio-group(
                                v-model="setting.color"
                                row
                                style="display: inline-block"
                            )
                            v-radio(
                                v-for="(item, i) in colors" 
                                :key="i"
                                :value="item.color"
                                :color="item.color"
                                active-class="active"
                                class="custom-radio"
                            )
                                template(v-slot:label class="custom-label")
                                    v-card(
                                        class="card-color elevation-0" 
                                    )
                                        img(:src="`assets/color/${item.image}`" height="44px")
                                    div(class="text-center mt-1 card-color__subtitle") {{ item.text }}

                                        PreviewSettingThemeColor(:color="setting.color")

                //- v-row(no-gutters)
                //-     v-col(cols="3") 
                //-         v-subheader 
                //-             span Email Sender
                //-             span.ml-1 
                //-                 v-tooltip(right)
                //-                     template(v-slot:activator="{ on, attrs }")
                //-                         v-icon(
                //-                             color="primary"
                //-                             v-bind="attrs"
                //-                             v-on="on"
                //-                             small
                //-                         ) help
                //-                     div Example email sender:
                //-                     div(class="yellow--text") noreply.imemo@techconnect.co.id
                //-     v-col(cols="5")
                //-         v-text-field(
                //-             v-model="setting.email"
                //-             label="Email Sender"
                //-             type="email"
                //-             :rules="[rules.email]"
                //-         )

                v-row(no-gutters)
                    v-col(cols="3") 
                        v-subheader 
                            span Footer Email/WhatsApp
                            span.ml-1 
                                v-tooltip(right max-width="350")
                                    template(v-slot:activator="{ on, attrs }")
                                        v-icon(
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                        ) help
                                    div Example 
                                    div(class="yellow--text") [Provided by iMemo TechConnect]
                    v-col(cols="6")
                        v-text-field(
                            v-model="setting.footer_notif"
                            label="Name"
                        )

                //- v-row(no-gutters)
                //-     v-col(cols="3") 
                //-         v-subheader Reminder All Pending Approval
                //-     v-col(cols="4" class="pr-5")
                //-         v-select(
                //-             v-model="setting.reminder_approval_days"
                //-             :items="days"
                //-             attach
                //-             chips
                //-             label="Choose Day (Max 2 day)"
                //-             multiple
                //-             deletable-chips
                //-             @input="limiter"
                //-         )
                //-     v-col(cols="2")
                //-         v-select(
                //-             v-model="setting.reminder_approval_time"
                //-             :items="times"
                //-             attach
                //-             chips
                //-             label="Time"
                //-             deletable-chips
                //-             item-text="name"
                //-             item-value="value"
                //-         )

                v-row 
                    v-col(md="4")
                        v-subheader(color="black") Header Logo
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderLogo.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderLogo"
                                v-model="setting.logo"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('logo')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isLogoValid"
                                @click="$refs.openPreviewLogo.dialog = true"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingLogo(:item="preview_logo" :color="setting.color" ref="openPreviewLogo")

                        v-chip(
                            v-if="setting.logo"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.logo = null; error.logo = false; preview_logo.url = null; preview_logo.name = null"
                        ) {{ logoName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.logo")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Full Approved Watermark
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderWmFullApprove.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderWmFullApprove"
                                v-model="setting.wm_full_approve"
                                accept="image/png, image/jpeg, image/bmp"
                                 @change="previewImage('wm_full_approve')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isWmFullApproveValid"
                                @click="showModalWatermark('wm_full_approve')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingWatermark(:item="preview_wm_full_approve" :color="setting.color" :dataType="type" ref="openPreviewWmFullApprove")

                        v-chip(
                            v-if="setting.wm_full_approve"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.wm_full_approve = null; error.wm_full_approve = false; preview_wm_full_approve.url = null; preview_wm_full_approve.name = null"
                        ) {{ wmFullApproveName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.wm_full_approve")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Rejected Watermark
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderWmReject.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderWmReject"
                                v-model="setting.wm_reject"
                                accept="image/png, image/jpeg, image/bmp"
                                 @change="previewImage('wm_reject')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isWmRejectValid"
                                @click="showModalWatermark('wm_reject')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingWatermark(:item="preview_wm_reject" :color="setting.color" :dataType="type" ref="openPreviewWmReject")

                        v-chip(
                            v-if="setting.wm_reject"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.wm_reject = null; error.wm_reject = false; preview_wm_reject.url = null; preview_wm_reject.name = null"
                        ) {{ wmRejectName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.wm_reject")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)
                v-row 
                    v-col(md="4")
                        v-subheader(color="black") On Approval Watermark
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderWmOnApproval.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderWmOnApproval"
                                v-model="setting.wm_on_approval"
                                accept="image/png, image/jpeg, image/bmp"
                                 @change="previewImage('wm_on_approval')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                 :disabled="!isWmOnApprovalValid"
                                @click="showModalWatermark('wm_on_approval')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingWatermark(:item="preview_wm_on_approval" :color="setting.color" :dataType="type" ref="openPreviewWmOnApproval")

                        v-chip(
                            v-if="setting.wm_on_approval"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.wm_on_approval = null; error.wm_on_approval = false; preview_wm_on_approval.url = null; preview_wm_on_approval.name = null"
                        ) {{ wmOnApprovalName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.wm_on_approval")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Withdraw Watermark
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderWmWithdraw.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderWmWithdraw"
                                v-model="setting.wm_withdraw"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('wm_withdraw')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isWmWithdrawValid"
                                @click="showModalWatermark('wm_withdraw')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingWatermark(:item="preview_wm_withdraw" :color="setting.color" :dataType="type" ref="openPreviewWmWithdraw")

                        v-chip(
                            v-if="setting.wm_withdraw"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.wm_withdraw = null; error.wm_withdraw = false; preview_wm_withdraw.url = null; preview_wm_withdraw.name = null"
                        ) {{ wmWithdrawName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.wm_withdraw")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Draft Watermark
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderWmDraft.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderWmDraft"
                                v-model="setting.wm_draft"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('wm_draft')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isWmDraftValid"
                                @click="showModalWatermark('wm_draft')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingWatermark(:item="preview_wm_draft" :color="setting.color" :dataType="type" ref="openPreviewWmDraft")

                        v-chip(
                            v-if="setting.wm_draft"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.wm_draft = null; error.wm_draft = false; preview_wm_draft.url = null; preview_wm_draft.name = null"
                        ) {{ wmDraftName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.wm_draft")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                v-row 
                    v-col(md="4")
                        v-subheader(color="black") Approval Sign Icon
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderIconApprove.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderIconApprove"
                                v-model="setting.icon_approve"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('icon_approve')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isIconApproveValid"
                                @click="showModalIcon('icon_approve')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingIcon(:item="preview_icon_approve" :color="setting.color" :dataType="type" ref="openPreviewIconApprove")

                        v-chip(
                            v-if="setting.icon_approve"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.icon_approve = null; error.icon_approve = false; preview_icon_approve.url = null; preview_icon_approve.name = null"
                        ) {{ wmIconApproveName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.icon_approve")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Rejection Sign Icon
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderIconReject.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderIconReject"
                                v-model="setting.icon_reject"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('icon_reject')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isIconRejectValid"
                                @click="showModalIcon('icon_reject')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingIcon(:item="preview_icon_reject" :color="setting.color" :dataType="type" ref="openPreviewIconReject")

                        v-chip(
                            v-if="setting.icon_reject"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.icon_reject = null; error.icon_reject = false; preview_icon_reject.url = null; preview_icon_reject.name = null"
                        ) {{ wmIconRejectName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.icon_reject")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                    v-col(md="4")
                        v-subheader(color="black") Withdraw Sign Icon
                        div(class="d-flex flex-row ml-3")
                            v-btn(
                                depressed
                                outlined
                                color="primary"
                                class="text-capitalize pt-5 pb-5"
                                @click="$refs.uploaderIconWithdraw.$refs.input.click()"
                            ) 
                                v-icon.mr-1 file_upload
                                | Upload File
                            v-file-input(
                                hide-input
                                ref="uploaderIconWithdraw"
                                v-model="setting.icon_withdraw"
                                accept="image/png, image/jpeg, image/bmp"
                                @change="previewImage('icon_withdraw')"
                                class="d-none"
                            )
                            v-btn(
                                depressed
                                color="primary"
                                class="ml-3 text-capitalize pt-5 pb-5"
                                :disabled="!isIconWithdrawValid"
                                @click="showModalIcon('icon_withdraw')"
                            ) 
                                v-icon.mr-1 remove_red_eye
                                |Preview

                            PreviewSettingIcon(:item="preview_icon_withdraw" :color="setting.color" :dataType="type" ref="openPreviewIconWithdraw")

                        v-chip(
                            v-if="setting.icon_withdraw"
                            class="ma-2 custom-chip"
                            close
                            @click:close="setting.icon_withdraw = null; error.icon_withdraw = false; preview_icon_withdraw.url = null; preview_icon_withdraw.name = null"
                        ) {{ wmIconWithdrawName | truncate(35, '...') }}

                        div.red--text.ml-2.mt-1(v-show="error.icon_withdraw")
                            v-icon(style="font-size: 18px;" color="red").mr-1 info 
                            small Upload failed (Max file 5 MB format JPG/PNG)

                v-card-actions.my-8
                    v-btn(
                        @click="$router.push('/')" 
                        class="elevation-0 custom__padding-btn mr-2"
                        v-if="$store.state.dataUsers.role=='admin'"
                    ) Back

                    v-btn(
                        @click="$router.push('/my-request')" 
                        class="elevation-0 custom__padding-btn mr-2"
                        v-else
                    ) Back

                    ResetSetting(:bu_id="bu_id")

                    v-btn(
                        class="elevation-0 custom__padding-btn"
                        color="blue-secondary"
                        @click="update()"
                        :disabled="!isBisnisUnit || isDisable"
                    ) Update

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import PreviewSettingLogo from "@/components/PreviewSettingLogo.vue";
import PreviewSettingIcon from "@/components/PreviewSettingIcon.vue";
import PreviewSettingWatermark from "@/components/PreviewSettingWatermark.vue";
import PreviewSettingThemeColor from "@/components/PreviewSettingThemeColor.vue";
import ResetSetting from "@/components/ResetSetting.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
    components: {
        PreviewSettingLogo,
        PreviewSettingIcon,
        PreviewSettingWatermark,
        PreviewSettingThemeColor,
        ResetSetting
    },
    data: () => ({
        setting: {
            bu: null,
            //- email: null,
            logo: null,
            color: null,
            footer_notif: null,
            reminder_approval_days: null,
            reminder_approval_time: null,
            icon_approve: null,
            icon_reject: null,
            icon_withdraw: null,
            wm_full_approve: null,
            wm_reject: null,
            wm_on_approval: null,
            wm_withdraw: null,
            wm_draft: null,
        },
        type: null,
        business_units: [],
        overlay: false,
        rules: {
            required: (value) => !!value || "This field is required.",
            email: (value) => {
                const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid email format";
            },
        },
        colors: [
            {
                color: '#D42A2A',
                image: 'red.png',
                text: 'Red'
            },
            {
                color: '#E91E63',
                image: 'Pink.png',
                text: 'Pink'
            },
            {
                color: '#9C27B0',
                image: 'Purple.png',
                text: 'Purple'
            },
            {
                color: '#2196F3',
                image: 'Blue.png',
                text: 'Blue'
            },
            {
                color: '#009688',
                image: 'Teal.png',
                text: 'Teal'
            }
        ],
        preview_logo: {
            url: null,
            name: null
        },
        preview_icon_approve: {
            url: null,
            name: null,
        },
        preview_icon_reject: {
            url: null,
            name: null
        },
        preview_icon_withdraw: {
            url: null,
            name: null,
        },
        preview_wm_full_approve: {
            position: "right",
            rotate: "yes",
            size: "large",
            name: null,
            url: null
        },
        preview_wm_reject: {
            position: "right",
            rotate: "yes",
            size: "large",
            name: null,
            url: null
        },
        preview_wm_on_approval: {
            position: "right",
            rotate: "yes",
            size: "large",
            name: null,
            url: null
        },
        preview_wm_draft: {
            position: "right",
            rotate: "yes",
            size: "large",
            name: null,
            url: null
        },
        preview_wm_withdraw: {
            position: "right",
            rotate: "yes",
            size: "large",
            name: null,
            url: null
        },
        isDisable: false,
        error: {
            logo: false,
            icon_approve: false,
            icon_reject: false,
            icon_withdraw: false,
            wm_full_approve: false,
            wm_reject: false,
            wm_on_approval: false,
            wm_withdraw: false,
            wm_draft: false,
        },
        days: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ],
        times: [
            {
                name: "09:00 AM",
                value: 9
            },
            {
                name: "13:00 PM",
                value: 13
            },
            {
                name: "17:00 PM",
                value: 17
            }
        ],
        bu_id: null
    }),
    computed: {
        ...mapState(["showDrawer"]),
        isLogoValid() {
            return this.setting.logo != null
        },
        isWmFullApproveValid() {
            return this.setting.wm_full_approve != null
        },
        isWmRejectValid() {
            return this.setting.wm_reject != null
        },
        isWmOnApprovalValid() {
            return this.setting.wm_on_approval != null
        },
        isWmWithdrawValid() {
            return this.setting.wm_withdraw != null
        },
        isWmDraftValid() {
            return this.setting.wm_draft != null
        },
        isIconApproveValid() {
            return this.setting.icon_approve != null
        },
        isIconRejectValid() {
            return this.setting.icon_reject != null
        },
        isIconWithdrawValid() {
            return this.setting.icon_withdraw != null
        },
        isBisnisUnit() {
            return this.setting.bu != null
        },
        logoName() {
            return this.preview_logo.name
        },
        wmFullApproveName() {
            return this.preview_wm_full_approve.name
        },
        wmOnApprovalName() {
            return this.preview_wm_on_approval.name
        },
        wmRejectName() {
            return this.preview_wm_reject.name
        },
        wmDraftName() {
            return this.preview_wm_draft.name
        },
        wmWithdrawName() {
            return this.preview_wm_withdraw.name
        },
        wmIconApproveName() {
            return this.preview_icon_approve.name
        },
        wmIconRejectName() {
            return this.preview_icon_reject.name
        },
        wmIconWithdrawName() {
            return this.preview_icon_withdraw.name
        }
    },
    mounted() {
        this.getBisnisUnit()
    },
    methods: {
        onButtonClick() {
            this.$refs.uploader.$refs.input.click()
        },
        showModalIcon(type) {
            switch(type) {
                case 'icon_approve' : 
                this.$refs.openPreviewIconApprove.dialog = true
                this.type = type
                break;

                case 'icon_reject' : 
                this.$refs.openPreviewIconReject.dialog = true
                this.type = type
                break;

                case 'icon_withdraw' : 
                this.$refs.openPreviewIconWithdraw.dialog = true
                this.type = type
                break;
            }
        },
        showModalWatermark(type) { 
            switch(type) {
                case 'wm_full_approve' : 
                this.$refs.openPreviewWmFullApprove.dialog = true 
                this.$refs.openPreviewWmFullApprove.wm_position = this.preview_wm_full_approve.position 
                this.$refs.openPreviewWmFullApprove.wm_rotate = this.preview_wm_full_approve.rotate 
                this.$refs.openPreviewWmFullApprove.wm_size = this.preview_wm_full_approve.size 
                break;

                case 'wm_on_approval' : 
                this.$refs.openPreviewWmOnApproval.dialog = true 
                this.$refs.openPreviewWmOnApproval.wm_position = this.preview_wm_on_approval.position 
                this.$refs.openPreviewWmOnApproval.wm_rotate = this.preview_wm_on_approval.rotate 
                this.$refs.openPreviewWmOnApproval.wm_size = this.preview_wm_on_approval.size 
                break;

                case 'wm_draft' : 
                this.$refs.openPreviewWmDraft.dialog = true
                this.$refs.openPreviewWmDraft.wm_position = this.preview_wm_draft.position 
                this.$refs.openPreviewWmDraft.wm_rotate = this.preview_wm_draft.rotate 
                this.$refs.openPreviewWmDraft.wm_size = this.preview_wm_draft.size 
                break;

                case 'wm_reject' : 
                this.$refs.openPreviewWmReject.dialog = true
                this.$refs.openPreviewWmReject.wm_position = this.preview_wm_reject.position 
                this.$refs.openPreviewWmReject.wm_rotate = this.preview_wm_reject.rotate 
                this.$refs.openPreviewWmReject.wm_size = this.preview_wm_reject.size 
                break;

                case 'wm_withdraw' : 
                this.$refs.openPreviewWmWithdraw.dialog = true
                this.$refs.openPreviewWmWithdraw.wm_position = this.preview_wm_withdraw.position 
                this.$refs.openPreviewWmWithdraw.wm_rotate = this.preview_wm_withdraw.rotate 
                this.$refs.openPreviewWmWithdraw.wm_size = this.preview_wm_withdraw.size 
                break;
            } 
        },  
        getBisnisUnit() {
            let token = localStorage.getItem("token");

            axios
            .get(process.env.VUE_APP_API+`/users/info`, {
            headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                if ( res.data.data.role == 'super_user' ) {
                    axios
                    .get(process.env.VUE_APP_API + `/business-unit/list/active`, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then((res) => {
                        let dataBU = res.data.data;
                        for (const item of dataBU) {
                            this.business_units.push({name: item.name, id: item._id, logo: item.logo});
                        }
                    })
                } else if ( res.data.data.role == 'admin' ) {
                    axios
                    .get(process.env.VUE_APP_API + `/business-unit/list`, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then((response) => {
                        let dataBU = response.data.data;
                        if ( res.data.data.user.hasOwnProperty('default_bu') ) {
                            for (const item of dataBU) {
                                if ( res.data.data.user.default_bu == item.id ) {
                                    this.setting.bu = item
                                } 
                                this.business_units.push({name: item.bu_name, id: item.id});
                            }
                        } else {
                            this.setting.bu = dataBU[0]
                        }

                        this.getData(this.setting.bu.id)
                    })
                }
            })
            .catch((err) => {
                if (err.response.status == 401 || err.response.status == 403) {
                    return this.$router.push("/logout");
                }
            })
        },
        getData(id) {
            this.overlay = true;
            this.bu_id = id;
            let token = localStorage.getItem("token");
            axios.get(
                process.env.VUE_APP_API +
                `/business-unit/detail/${id}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
            )
            .then((res) => {
                this.overlay = false

                this.setting.color = res.data.settings && res.data.settings.themeColors 
                    ? res.data.settings.themeColors 
                    : "#D42A2A"

                //- this.setting.email = res.data.settings.emailSender

                this.setting.footer_notif = res.data.settings && res.data.settings.footerEmailWhatsApp 
                    ? res.data.settings.footerEmailWhatsApp 
                    : null

                this.setting.reminder_approval_days = res.data.settings && res.data.settings.reminderApproval 
                    ? res.data.settings.reminderApproval 
                    : null
                
                this.setting.reminder_approval_time = res.data.settings && res.data.settings.reminderApprovalHrs
                    ? res.data.settings.reminderApprovalHrs
                    : null

                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('headerLogo') ) {
                    this.setting.logo = res.data.settings.headerLogo.src
                    this.preview_logo.url = res.data.settings.headerLogo.src
                    this.preview_logo.name = res.data.settings.headerLogo.srcName
                } else {
                    this.setting.logo = null
                    this.preview_logo.url = null
                    this.preview_logo.name = null
                }

                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('fullApprovedWatermark') ) {
                    this.setting.wm_full_approve = res.data.settings.fullApprovedWatermark.src 
                    this.preview_wm_full_approve.url = res.data.settings.fullApprovedWatermark.src 
                    this.preview_wm_full_approve.position = res.data.settings.fullApprovedWatermark.align
                    this.preview_wm_full_approve.rotate = res.data.settings.fullApprovedWatermark.rotate == true ? "yes" : "no"
                    this.preview_wm_full_approve.size = res.data.settings.fullApprovedWatermark.size 
                    this.preview_wm_full_approve.name = res.data.settings.fullApprovedWatermark.srcName
                } else {
                    this.setting.wm_full_approve = null
                    this.preview_wm_full_approve.url = null
                    this.preview_wm_full_approve.position = "right"
                    this.preview_wm_full_approve.rotate = "yes"
                    this.preview_wm_full_approve.size = "large"
                    this.preview_wm_full_approve.name = null
                }

                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('rejectedWatermark') ) {
                    this.setting.wm_reject = res.data.settings.rejectedWatermark.src 
                    this.preview_wm_reject.url = res.data.settings.rejectedWatermark.src 
                    this.preview_wm_reject.position = res.data.settings.rejectedWatermark.align
                    this.preview_wm_reject.rotate = res.data.settings.rejectedWatermark.rotate == true ? "yes" : "no"
                    this.preview_wm_reject.size = res.data.settings.rejectedWatermark.size 
                    this.preview_wm_reject.name = res.data.settings.rejectedWatermark.srcName
                } else {
                    this.setting.wm_reject = null
                    this.preview_wm_reject.url = null
                    this.preview_wm_reject.position = "right"
                    this.preview_wm_reject.rotate = "yes"
                    this.preview_wm_reject.size = "large"
                    this.preview_wm_reject.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('onApprovalWatermark') ) {
                    this.setting.wm_on_approval = res.data.settings.onApprovalWatermark.src 
                    this.preview_wm_on_approval.url = res.data.settings.onApprovalWatermark.src 
                    this.preview_wm_on_approval.position = res.data.settings.onApprovalWatermark.align
                    this.preview_wm_on_approval.rotate = res.data.settings.onApprovalWatermark.rotate == true ? "yes" : "no"
                    this.preview_wm_on_approval.size = res.data.settings.onApprovalWatermark.size 
                    this.preview_wm_on_approval.name = res.data.settings.onApprovalWatermark.srcName
                } else {
                    this.setting.wm_on_approval = null
                    this.preview_wm_on_approval.url = null
                    this.preview_wm_on_approval.position = "right"
                    this.preview_wm_on_approval.rotate = "yes"
                    this.preview_wm_on_approval.size = "large"
                    this.preview_wm_on_approval.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('withdrawWatermark') ) {
                    this.setting.wm_withdraw = res.data.settings.withdrawWatermark.src 
                    this.preview_wm_withdraw.url = res.data.settings.withdrawWatermark.src 
                    this.preview_wm_withdraw.position = res.data.settings.withdrawWatermark.align
                    this.preview_wm_withdraw.rotate = res.data.settings.withdrawWatermark.rotate == true ? "yes" : "no"
                    this.preview_wm_withdraw.size = res.data.settings.withdrawWatermark.size 
                    this.preview_wm_withdraw.name = res.data.settings.withdrawWatermark.srcName
                } else {
                    this.setting.wm_withdraw = null
                    this.preview_wm_withdraw.url = null
                    this.preview_wm_withdraw.position = "right"
                    this.preview_wm_withdraw.rotate = "yes"
                    this.preview_wm_withdraw.size = "large"
                    this.preview_wm_withdraw.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('draftWatermark') ) {
                    this.setting.wm_draft = res.data.settings.draftWatermark.src 
                    this.preview_wm_draft.url = res.data.settings.draftWatermark.src 
                    this.preview_wm_draft.position = res.data.settings.draftWatermark.align
                    this.preview_wm_draft.rotate = res.data.settings.draftWatermark.rotate == true ? "yes" : "no"
                    this.preview_wm_draft.size = res.data.settings.draftWatermark.size 
                    this.preview_wm_draft.name = res.data.settings.draftWatermark.srcName
                } else {
                    this.setting.wm_draft = null
                    this.preview_wm_draft.url = null
                    this.preview_wm_draft.position = "right"
                    this.preview_wm_draft.rotate = "yes"
                    this.preview_wm_draft.size = "large"
                    this.preview_wm_draft.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('approvalSignIcon') ) {
                    this.setting.icon_approve = res.data.settings.approvalSignIcon.src 
                    this.preview_icon_approve.url = res.data.settings.approvalSignIcon.src
                    this.preview_icon_approve.name = res.data.settings.approvalSignIcon.srcName
                } else {
                    this.setting.icon_approve = null
                    this.preview_icon_approve.url = null
                    this.preview_icon_approve.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('rejectionSignIcon') ) {
                    this.setting.icon_reject = res.data.settings.rejectionSignIcon.src 
                    this.preview_icon_reject.url = res.data.settings.rejectionSignIcon.src
                    this.preview_icon_reject.name = res.data.settings.rejectionSignIcon.srcName
                } else {
                    this.setting.icon_reject = null
                    this.preview_icon_reject.url = null
                    this.preview_icon_reject.name = null
                }
                
                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('withdrawSignIcon') ) {
                    this.setting.icon_withdraw = res.data.settings.withdrawSignIcon.src 
                    this.preview_icon_withdraw.url = res.data.settings.withdrawSignIcon.src
                    this.preview_icon_withdraw.name = res.data.settings.withdrawSignIcon.srcName
                } else {
                    this.setting.icon_withdraw = null
                    this.preview_icon_withdraw.url = null
                    this.preview_icon_withdraw.name = null
                }
            })
            .catch((err) => {
                this.overlay = false;
                this.$toasted.error(err, { icon: "error" });
            })
            .finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        previewImage(type) {

            switch(type) {
                case 'logo' : 
                    if ( this.setting.logo.size > 5000000 ) {
                        this.setting.logo = null
                        this.error.logo = true
                        this.isDisable = true
                    } else {
                        this.error.logo = false
                        this.isDisable = false
                    }
                    this.preview_logo.url = URL.createObjectURL(this.setting.logo)
                    this.preview_logo.name = this.setting.logo.name
                break;

                case 'icon_approve' : 
                    if ( this.setting.icon_approve.size > 5000000 ) {
                        this.setting.icon_approve = null
                        this.error.icon_approve = true
                        this.isDisable = true
                    } else {
                        this.error.icon_approve = false
                        this.isDisable = false
                    }
                    this.preview_icon_approve.url = URL.createObjectURL(this.setting.icon_approve)
                    this.preview_icon_approve.name = this.setting.icon_approve.name
                break;

                case 'icon_reject' : 
                    if ( this.setting.icon_reject.size > 5000000 ) {
                        this.setting.icon_reject = null
                        this.error.icon_reject = true
                        this.isDisable = true
                    } else {
                        this.error.icon_reject = false
                        this.isDisable = false
                    }
                    this.preview_icon_reject.url = URL.createObjectURL(this.setting.icon_reject)
                    this.preview_icon_reject.name = this.setting.icon_reject.name
                break;

                case 'icon_withdraw' : 
                    if ( this.setting.icon_withdraw.size > 5000000 ) {
                        this.setting.icon_withdraw = null
                        this.error.icon_withdraw = true
                        this.isDisable = true
                    } else {
                        this.error.icon_withdraw = false
                        this.isDisable = false
                    }
                    this.preview_icon_withdraw.url = URL.createObjectURL(this.setting.icon_withdraw)
                    this.preview_icon_withdraw.name = this.setting.icon_withdraw.name
                break;

                case 'wm_full_approve' : 
                    if ( this.setting.wm_full_approve.size > 5000000 ) {
                        this.setting.wm_full_approve = null
                        this.error.wm_full_approve = true
                        this.isDisable = true
                    } else {
                        this.error.wm_full_approve = false
                        this.isDisable = false
                    }
                    this.preview_wm_full_approve.url = URL.createObjectURL(this.setting.wm_full_approve)
                    this.preview_wm_full_approve.name = this.setting.wm_full_approve.name
                break;

                case 'wm_on_approval' : 
                    if ( this.setting.wm_on_approval.size > 5000000 ) {
                        this.setting.wm_on_approval = null
                        this.error.wm_on_approval = true
                        this.isDisable = true
                    } else {
                        this.error.wm_on_approval = false
                        this.isDisable = false
                    }
                    this.preview_wm_on_approval.url = URL.createObjectURL(this.setting.wm_on_approval)
                    this.preview_wm_on_approval.name = this.setting.wm_on_approval.name
                break;

                case 'wm_draft' : 
                    if ( this.setting.wm_draft.size > 5000000 ) {
                        this.setting.wm_draft = null
                        this.error.wm_draft = true
                        this.isDisable = true
                    } else {
                        this.error.wm_draft = false
                        this.isDisable = false
                    }
                    this.preview_wm_draft.url = URL.createObjectURL(this.setting.wm_draft)
                    this.preview_wm_draft.name = this.setting.wm_draft.name
                break;

                case 'wm_reject' : 
                    if ( this.setting.wm_reject.size > 5000000 ) {
                        this.setting.wm_reject = null
                        this.error.wm_reject = true
                        this.isDisable = true
                    } else {
                        this.error.wm_reject = false
                        this.isDisable = false
                    }
                    this.preview_wm_reject.url = URL.createObjectURL(this.setting.wm_reject)
                    this.preview_wm_reject.name = this.setting.wm_reject.name
                break;

                case 'wm_withdraw' : 
                    if ( this.setting.wm_withdraw.size > 5000000 ) {
                        this.setting.wm_withdraw = null
                        this.error.wm_withdraw = true
                        this.isDisable = true
                    } else {
                        this.error.wm_withdraw = false
                        this.isDisable = false
                    }
                    this.preview_wm_withdraw.url = URL.createObjectURL(this.setting.wm_withdraw)
                    this.preview_wm_withdraw.name = this.setting.wm_withdraw.name
                break;
            } 
        },
        changeImageUrl: async function() {
            if (this.setting.logo && typeof this.setting.logo.name == 'string') {
                await this.UploadAttachtment(this.setting.logo, 'logo');
            } 

            if (this.setting.icon_approve && typeof this.setting.icon_approve.name == 'string') {
                await this.UploadAttachtment(this.setting.icon_approve, 'icon_approve');
            }

            if (this.setting.icon_reject && typeof this.setting.icon_reject.name == 'string') {
                await this.UploadAttachtment(this.setting.icon_reject, 'icon_reject');
            }

            if (this.setting.icon_withdraw && typeof this.setting.icon_withdraw.name == 'string') {
                await this.UploadAttachtment(this.setting.icon_withdraw, 'icon_withdraw');
            }

            if (this.setting.wm_full_approve && typeof this.setting.wm_full_approve.name == 'string') {
                await this.UploadAttachtment(this.setting.wm_full_approve, 'wm_full_approve');
            }

            if (this.setting.wm_reject && typeof this.setting.wm_reject.name == 'string') {
                await this.UploadAttachtment(this.setting.wm_reject, 'wm_reject');
            }

            if (this.setting.wm_on_approval && typeof this.setting.wm_on_approval.name == 'string') {
                await this.UploadAttachtment(this.setting.wm_on_approval, 'wm_on_approval');
            }

            if (this.setting.wm_withdraw && typeof this.setting.wm_withdraw.name == 'string') {
                await this.UploadAttachtment(this.setting.wm_withdraw, 'wm_withdraw');
            }

            if (this.setting.wm_draft && typeof this.setting.wm_draft.name == 'string') {
                await this.UploadAttachtment(this.setting.wm_draft, 'wm_draft');
            }
        },
        UploadAttachtment: async function(data, type){
            let formData = new FormData();
            formData.append("attachment", data);
            const config = {
                method: "post",
                url: process.env.VUE_APP_API+`/memo/upload-file`,
                headers: {
                Authorization: `Bearer ${this.$store.state.token}`,
                    "Content-Type": "multipart/form-data",
                },
                data: formData,
            };
            await axios(config).then((res) => {
                if ( type == 'logo' ) {
                    this.preview_logo.url = res.data.data.url 
                    this.preview_logo.name = res.data.data.name
                }

                if ( type == 'icon_approve' ) {
                    this.preview_icon_approve.url = res.data.data.url 
                    this.preview_icon_approve.name = res.data.data.name
                }

                if ( type == 'icon_reject' ) {
                    this.preview_icon_reject.url = res.data.data.url 
                    this.preview_icon_reject.name = res.data.data.name
                }

                if ( type == 'icon_withdraw' ) {
                    this.preview_icon_withdraw.url = res.data.data.url 
                    this.preview_icon_withdraw.name = res.data.data.name
                }

                if ( type == 'wm_full_approve' ) {
                    this.preview_wm_full_approve.url = res.data.data.url 
                    this.preview_wm_full_approve.name = res.data.data.name 
                }

                if ( type == 'wm_on_approval' ) {
                    this.preview_wm_on_approval.url = res.data.data.url 
                    this.preview_wm_on_approval.name = res.data.data.name 
                }

                if ( type == 'wm_draft' ) {
                    this.preview_wm_draft.url = res.data.data.url 
                    this.preview_wm_draft.name = res.data.data.name 
                }

                if ( type == 'wm_reject' ) {
                    this.preview_wm_reject.url = res.data.data.url 
                    this.preview_wm_reject.name = res.data.data.name 
                }

                if ( type == 'wm_withdraw' ) {
                    this.preview_wm_withdraw.url = res.data.data.url 
                    this.preview_wm_withdraw.name = res.data.data.name 
                }

            }).catch(err => {
                console.log(err)
                let err_msg= err.response.data.message
                this.$toasted.error(err_msg, { icon : 'error'})
            })
        },
        update: async function() {
            this.overlay = true;
            await this.changeImageUrl();
            this.preview_wm_full_approve.rotate = this.preview_wm_full_approve.rotate == "yes" ? true : false;
            this.preview_wm_on_approval.rotate = this.preview_wm_on_approval.rotate == "yes" ? true : false;
            this.preview_wm_reject.rotate = this.preview_wm_reject.rotate == "yes" ? true : false;
            this.preview_wm_draft.rotate = this.preview_wm_draft.rotate == "yes" ? true : false;
            this.preview_wm_withdraw.rotate = this.preview_wm_withdraw.rotate == "yes" ? true : false;

            this.setting.bu = this.setting.bu.id

            this.$store.dispatch("updateDataSetting", {
                setting: this.setting,
                preview_logo: this.preview_logo,
                preview_wm_full_approve: this.preview_wm_full_approve,
                preview_wm_on_approval: this.preview_wm_on_approval,
                preview_wm_reject: this.preview_wm_reject,
                preview_wm_draft: this.preview_wm_draft,
                preview_wm_withdraw: this.preview_wm_withdraw, 
                preview_icon_approve: this.preview_icon_approve,
                preview_icon_reject: this.preview_icon_reject,
                preview_icon_withdraw: this.preview_icon_withdraw
            })
            .then((res) => {
                this.overlay = false;
                if (this.showDrawer) this.$store.commit("toggleDrawer");

                if( this.$store.state.dataUsers.user.hasOwnProperty('default_bu') && this.$store.state.dataUsers.role != "super_user") {
                    if ( this.$store.state.dataUsers.user.default_bu == res.data.data._id ) {
                        this.$store.commit("setThemeColor", res.data.data.settings.themeColors)
                        this.$store.commit("setLogo", res.data.data.settings.headerLogo.src != null ? res.data.data.settings.headerLogo.src : require('../assets/imemo-white-text.png'))
                    }
                }
                this.$toasted.success("Data updated successfully", {
                    icon: "check_circle",
                });
                setTimeout(function(){
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                this.overlay = false;
                this.$toasted.error(err.response.data.message, { icon: "error" });
            });
        },
        limiter(e) {
            if(e.length > 2) {
                this.$toasted.error("You can only select two days", { icon: "error" })
                e.pop()
            }
        },
    }
};
</script>

<style>
    button.custom__padding-btn {
        padding: 1.4rem 2rem !important;
    }

    .title-setting{
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        margin-left: 1rem;
        margin-bottom: 0.6rem;
    }

    .card-color{
        border: 2px solid #D9D9D9 !important;
        padding: 0.2rem;
    }

    .active .card-color{
        border: 2px solid #1976D2 !important;
    }

    .card-color__subtitle{
        font-size: 12px;
        color: black;
    }

    .custom-radio .v-input--selection-controls__input .v-icon {
        display: none;
    }
    
    .custom-radio label{
        margin-left: -2.1rem;
        display: block !important;
    }

    .custom-input .v-input__slot { 
       padding-top: 0px;
        padding-right: 12px;
        padding-bottom: 0px;
        padding-left: 6px !important;
    }

    .custom-chip{
        background: rgba(25, 118, 210, 0.1) !important;
        color: #1976D2 !important;
    }

    .custom-chip .v-icon{
        color: #1976D2 !important;
    }

    button.icon-detail{
        visibility: hidden;
    }

    .active button.icon-detail{
        visibility: visible;
    }
</style>